module.exports = __webpack_public_path__ + "img/5502875.d1d348d5.jpg";